/**
 * `/klienci/formularz` — the builder's address until it moved to `/strona` on 28 September 2026.
 * Kept as a redirect so a bookmark or an older link still lands on it.
 *
 * `replace: true`, so the old address leaves no history entry behind: Back from the builder goes
 * wherever the trainer was before, not to `/klienci/formularz`, which would bounce them forward.
 *
 * The static segment still beats `/klienci/$clientId`: TanStack Router ranks a literal above a
 * parameter, so no client whose id is the word „formularz" can shadow it.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/klienci/formularz')({
  beforeLoad: () => {
    // `throw: true` makes `redirect` raise the router's own Response itself; see `_shell.tsx`.
    redirect({ to: '/strona', replace: true, throw: true });
  },
});
